import React from 'react'
import contact2 from '../../assets/contacts/contact2.svg';
import ContactElement from './ContactElement';
const Reports = () => {

    const details = {
        type: "Report Concern!",
        title: "Got concerns? We’re here to listen!",
        img: contact2,
        submit: "Submit Concern"
    }

    return (
        <div className="pt-[100px] md:pt-[120px]"> 
            <ContactElement details={details} />
        </div>

    )

}

export default Reports
